<template>
  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item>Product Catalogue</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <div class="actions-bar">
      <el-row>
        <el-col :span="8">
          <el-input placeholder="Search by name or SKU" v-on:keyup.native="search" v-model="search_terms" :disabled="!picked_category">
            <template slot="append"><el-button slot="append" icon="el-icon-search"></el-button></template>
          </el-input>
        </el-col>
        <el-col :span="14" :offset="2" class="text-right">
          <el-button v-if="picked_category" @click="picked_category = false">Clear Selection</el-button>
          <el-select 
            v-model="product_category_id" 
            placeholder="Select Category"
            @change="search(), picked_category = true"
            :filterable="true"
            :clearable="true"
            @clear="picked_category = false"
            value-key="id">
            <el-option v-for="category in product_categories" :key="category.id" :label="category.name" :value="category.id"></el-option>
        </el-select>
        </el-col>
      </el-row>
    </div>

    <el-alert
      v-if="products.length == 0 && loading === false && picked_category"
      title="No Products Match"
      type="info"
      style="margin-bottom:25px">
    </el-alert>

    <!-- DISPLAYING CATEGORIES NEW VERSION -->
    <el-row v-if="!picked_category" :gutter="30" class="template-row-flex" v-loading.body="loading">

  		<el-col v-for="(product_category_group,index) in product_category_groups" :key="index" :span="6" style="margin-top: 25px">
		   
        <el-card shadow="hover" style="min-height: 225px">

          <div slot="header" class="clearfix" style="line-height: 36px;">
            <strong>{{ product_category_group.name }}</strong> 
          </div>
          <ul class="category-list">
            <li 
              v-for="category in product_category_group.category" 
              :key="category.id"
              @click="categorySelection(category.id)"> 
              {{ category.name }}
            </li>
          </ul>
        </el-card>

    	</el-col>

	  </el-row>
    <!-- DISPLAYING CATEGORIES NEW VERSION -->

    <!-- DISPLAYING PRODUCTS -->
	  <el-row v-if="picked_category" :gutter="30" class="template-row-flex" v-loading.body="loading">
  		<el-col v-for="(product,index) in products" :key="index" :span="6" :lg="6" :md="8" :sm="8" :xs="12" class="template-card-col">
		    <el-card :body-style="{ padding: '0px' }">
				<div v-if="product.product_images.length">
				    <img @click="viewProduct(product.id)" v-bind:src="product.product_images[0].path" class="img-responsive mimic-link" :alt="product.display_name">
				</div>
				<div v-else>
				  <img @click="getProduct(product.id)" src="static/img/placeholder-image.jpg" class="img-responsive mimic-link" :alt="product.display_name">
				</div>
		      <img src="" class="image">
		      <div style="padding: 14px;" class="text-center">
		        <span>{{product.name}}</span>
		        <div class="bottom clearfix mt-20">
		          <el-button type="primary" size="medium" @click="getProduct(product.id)">View Product</el-button>
		        </div>
		      </div>
	    	</el-card>
    	</el-col>
	  </el-row>
    <!-- DISPLAYING PRODUCTS -->

    <el-row v-if="picked_category" :gutter="0">
      <el-col :span="24" :xs="24" :sm="24" class="pagination">
        <el-pagination
          v-if="pagination.total != 0"
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.current_page"
          :page-count="pagination.total_pages"
          :page-size="pagination.per_page"
          layout="total, prev, pager, next"
          :total="pagination.total">
        </el-pagination>
      </el-col>
    </el-row>

    <el-dialog
      :title="product.name"
      :visible.sync="dialogVisibleProductInfo"
      :fullscreen="false"
      :before-close="handleCloseProductInfo"
      :lock-scroll="false"
      width="70%"
      :modal-append-to-body="true">

      <el-row :gutter="20">

        <el-col :span="10">
          <div class="bottom-spacer">
            <transition name="fade">
              <img :src="primary_image" :alt="product.name" class="image-thumb">
            </transition>
          </div>

          <el-row :gutter="10">
            <el-col :span="6" v-for="(image,index) in product.product_images" :key="index" class="bottom-spacer">
              <img :id="index" :src="image.path" :alt="product.name" class="image-thumb" v-bind:class="{ active: image.path == primary_image }" @click="changePrimaryImage(image.path)">
            </el-col>
          </el-row>
			  </el-col>

			  <el-col :span="14">
          <el-tabs type="card" v-model="active_tab">

            <el-tab-pane label="Details" name="details">

              <ul class="breakdown">
                <li class="clearfix">
                  <span class="param">SKU</span>
                  <span class="value">{{product.sku}}</span>
                </li>
                <li class="clearfix">
                  <span class="param">Specification</span>
                  <span class="value">{{product.specification}}</span>
                </li>
                <li class="clearfix">
                  <span class="param">Short Description</span>
                  <span class="value">{{product.short_description}}</span>
                </li>
                <li class="clearfix">
                  <span class="param">Description</span>
                  <span class="value">{{product.description}}</span>
                </li>
              </ul>

            </el-tab-pane>

            <el-tab-pane label="Pricing" name="pricing">

              <el-table 
                v-loading.body="loading"
                :data="product.product_shipping_matrix"
                border
                resizable="true"
                style="width: 100%">
                
                <el-table-column
                  v-if="pricing_tiers_columns.id"
                  prop="id"
                  label="ID"
                  width="115%">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.country"
                  prop="country"
                  label="Country">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.min_qty"
                  prop="min_qty"
                  label="Qty">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.state"
                  prop="state"
                  label="State">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.zip"
                  prop="zip"
                  label="Zip">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.city"
                  prop="city"
                  label="City">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.min_qty"
                  prop="min_qty"
                  label="Minimum Quantity">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.max_qty"
                  prop="max_qty"
                  label="Maximum Quantity">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.product_turnaround_time"
                  prop="product_turnaround_time"
                  label="Turnaround Time">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.product_cost_price"
                  prop="product_cost_price"
                  label="Cost Price">
                  <template slot-scope="scope">
                    {{scope.row.product_cost_price | toCurrency}}
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.product_retail_price"
                  prop="product_retail_price"
                  label="RRP">
                  <template slot-scope="scope">
                    {{scope.row.product_retail_price | toCurrency}}
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.pack_cost_price"
                  prop="pack_cost_price"
                  label="Pack Cost Price">
                  <template slot-scope="scope">
                    {{scope.row.pack_cost_price | toCurrency}}
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.pack_retail_price"
                  prop="pack_retail_price"
                  label="Pack Retail Price">
                  <template slot-scope="scope">
                    {{scope.row.pack_retail_price | toCurrency}}
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.pack_discount"
                  prop="pack_discount"
                  label="Pack Discount">
                  <template slot-scope="scope">
                    {{scope.row.pack_discount | toCurrency}}
                  </template>
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.pack_max_quantity"
                  prop="pack_max_quantity"
                  label="Pack Maximum Quantity">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.pack_weight"
                  prop="pack_weight"
                  label="Pack Weight">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.supplier_name"
                  prop="supplier.name"
                  label="Suppler">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.margin"
                  label="Margin">
                  <template slot-scope="scope">
                    {{ calculateMargin(scope.row) }}%
                  </template>         
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.print_type_name"
                  prop="print_type.name"
                  label="Print Type">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.tax_class_name"
                  prop="tax_class.name"
                  label="Shipping Tax Class">
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.created_at"
                  align="center"
                  width="115%"
                  prop="created_at"
                  label="Created Date">
                  <template slot-scope="scope">
                    {{scope.row.created_at | moment(config.date_format_compact)}}
                  </template>          
                </el-table-column>

                <el-table-column
                  v-if="pricing_tiers_columns.updated_at"
                  align="center"
                  width="115%"
                  prop="updated_at"
                  label="Updated Date">
                  <template slot-scope="scope">
                    {{scope.row.updated_at | moment(config.date_format_compact)}}
                  </template>          
                </el-table-column>
              </el-table>
              
            </el-tab-pane>

            <el-tab-pane label="Quote" name="quote" v-loading="loading_add_to_quote">

              <el-card style="margin-bottom: 20px;" shadow="never">
                <div slot="header" class="clearfix" style="line-height: 26px;">
                  <span>Country and Quantity</span>
                </div>

                <el-row :gutter="20" class="bottom-spacer">
                  <el-col :span="12">
                    <el-select  
                      v-model="selected_country" 
                      placeholder="Select Country"
                      :clearable="true"
                      @change="getCountryTiers()"
                      filterable>
                      <el-option
                        v-for="item in countries"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name">
                      </el-option>
                    </el-select>
                  </el-col>

                  <el-col :span="12">
                    <div v-if="product.is_tiered">
                      <el-select  
                        v-if="country_tiers.length > 0"
                        v-model="quote.selected_tier" 
                        placeholder="Select Quantity"
                        :clearable="true"
                        value-key="min_qty">
                        <el-option
                          v-for="item in country_tiers"
                          :key="item.min_qty"
                          :label="item.min_qty"
                          :value="item">
                        </el-option>
                      </el-select>
                    </div>

                    <div v-else>
                      <el-input-number 
                        @change="whichTierToUse()"
                        v-if="country_tiers.length" 
                        v-model="quote.quantity" 
                        controls-position="right" 
                        :min="non_tiered_minimum">
                      </el-input-number>
                    </div>
                  </el-col>
                </el-row>

                <el-alert 
                  v-if="selected_country && !country_tiers.length"
                  style="margin-top: 20px;"
                  title="There are no pricing options available for this country"
                  type="error"
                  show-icon>
                </el-alert>
              </el-card>

              <el-card style="margin-bottom: 20px;" shadow="never">
                <div slot="header" class="clearfix" style="line-height: 26px;">
                  <span>Choose Markup</span>
                </div>
                
                <div v-if="product.min_recommended_margin == 0 && product.max_recommended_margin == 0">
                  <div style="margin-top: 15px;" >
                    <el-input 
                      placeholder="Please Enter" 
                      v-model="quote.markup"
                      :min="0"
                      :max="100"
                      :step="5"
                      :show-stops="false">
                      <template slot="append">%</template>
                    </el-input>
                  </div>
                </div>

                <div v-else>
                  <el-input
                    v-model="quote.markup"
                    :min="product.min_recommended_margin"
                    :max="product.max_recommended_margin"
                    :step="5"
                    :show-stops="false">
                  </el-input>
                </div>
              </el-card>

              <el-card style="margin-bottom: 20px;" shadow="never">
                <div slot="header" class="clearfix" style="line-height: 26px;">
                  <span>Pricing</span>

                  <el-switch
                    :active-value="1"
                    :inactive-value="0"
                    active-text="Unit Price"
                    inactive-text="Total Price"
                    style="float:right"
                    v-model="quote.unit_price_selected">
                  </el-switch>
                </div>

                <div v-if="product.is_tiered">
                  <p>Cost Price: <strong>{{tieredCostPrice | toCurrency}}</strong></p>
                  <p>Sell Price: <strong>{{tieredSellPrice | toCurrency}}</strong></p>
                  <p>Profit Margin Percentage: <strong>{{tieredGrossProfit}}<span v-if="quote.sell_price">%</span></strong></p>
                </div>

                <div v-else>
                  <p>Cost Price: <strong>{{nonTieredCostPrice | toCurrency}}</strong></p>
                  <p>Sell Price: <strong>{{nonTieredSellPrice | toCurrency}}</strong></p>
                  <p>Profit Margin Percentage: <strong>{{nonTieredGrossProfit}}<span v-if="quote.sell_price">%</span></strong></p>
                </div>

                <el-button type="primary" :disabled="checkAddQuote == false || loading_add_to_quote == true" @click="addToQuote(product)">Add to Quote</el-button>
              </el-card>
            
            </el-tab-pane>

          </el-tabs>
        </el-col>

      </el-row>
    </el-dialog>

    <pre>{{$data}}</pre>

  </div>
</template>

<style scoped>
  .template-row-flex {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .template-card-col {
    margin-bottom: 30px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .image-thumb {
    width: 100%;
    display: block;
    border: 1px solid #fff;
  }

  .image-thumb.active {
    border: 1px solid #909399;
  }

  .bottom-spacer {
    margin-bottom: 10px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .9s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  ul.breakdown {
    margin:0;
    padding:0;
    list-style: none;
  }

  ul.breakdown li {
    margin:5px 0 10px 0;
    padding:5px 0;
    border-bottom:1px solid #E4E7ED;
    list-style: none;
  }

  /* ul.breakdown li:first-child {
    margin:5px 0;
    padding:5px 0;
    border-top:1px solid #E4E7ED;
    list-style: none;
  } */

  ul.breakdown li span.param {
    display:inline-block;
    width:29%;
    font-weight: bold;
  }

  ul.breakdown li span.value {
    display:inline-block;
    width:70%;
  }

  .clearfix {
    overflow: auto;
  }

  .clearfix::after {
    content: "";
    clear: both;
    display: table;
  }

  .block-padding {
    padding:12px;
  }

  .mt-20 {
    margin-top:20px;
  }

  ul.category-list {
    margin:0;
    padding:0;
    list-style:none;
  }


  ul.category-list li {
    margin:0;
    padding:6px;
    cursor: pointer;
    border-radius: 4px;
  }

  ul.category-list li:hover {
    background:#F9FAFC;
  }


</style>

<script>
             
  import Config from '@/store/Config.js';
  import Quotes from '@/store/QuoteStash.js';
  import Tables from '@/store/Tables.js';
  import CountryList from '@/components/utils/CountryList.js';
  import Utils from '@/components/utils/Utils.js';

  export default {
    data: function() {
      return {    
        page_alias: 'Product Catalogue',
        page_slug: 'product-catalogue',

        quotes: Quotes.state.quotes,
        quote_meta: Quotes.state,
        config: Config.config,
        pricing_tiers_columns: Tables.pricing_tiers_quote.columns,
        countries: CountryList.countries,

        picked_category: false,

        search_terms: '',
        active_tab: 'details',
        loading: false,
        loading_add_to_quote: false,
        dialogVisibleProductInfo: false,   

        product_category_groups: [],

        product_category_id: '',
        product_categories: [],
        
        products: [],
        product: {product_shipping_matrix: []},
        country_tiers: [],
        selected_country: 'Ireland',

        primary_image: '',

        quote: {
          selected_tier: {},
          quantity: 0,
          markup: 0,
          unit_price_selected: 0,
          cost_price: '',
          sell_price: '',
          gross_profit: ''
        },

        non_tiered_minimum: 0,
        non_tiered_maximum: 100,

        user: {},
            
        pagination: {
          total: 0,
          per_page: 0,
          current_page: 0,
          last_page: 0,
          next_page_url: '',
          prev_page_url: '',
          from: 0,
          to: 0,
        }
      };
    },

    mounted: function() {
      const me = this;

      me.getUser();
      me.getProductCategoryGroups();
      me.getProductCategories();

      /* me.getProducts(); */
    },

    computed: {
      checkAddQuote: function() {
        const me = this;
        
        if(me.tieredNotEmpty() || me.nonTieredNotEmpty () ) {
          return true;
        }
        
        return false;
				
      },

      /* TIERED FUNCTIONS */
      tieredCostPrice() {
        const me = this;
        console.log('Tiered Unit Cost Price Computed');

        if(me.tieredNotEmpty()) {
          console.log('Tiered Unit Cost Price Computed (Entered)');

          if(me.quote.unit_price_selected) {
            me.quote.cost_price = me.quote.selected_tier.product_cost_price / me.quote.selected_tier.min_qty;
          } else {
            me.quote.cost_price = me.quote.selected_tier.product_cost_price;
          }

          return me.quote.cost_price;
        }
      },

      tieredSellPrice() {
        const me = this;
        console.log('Tiered Unit Sell Price Computed');

        if(me.tieredNotEmpty()) {
          console.log('Tiered Unit Sell Price Computed (Entered)');

          if(me.quote.unit_price_selected) {
            me.quote.sell_price = (me.quote.selected_tier.product_cost_price / me.quote.selected_tier.min_qty) * ((me.quote.markup / 100) + 1);
          } else {
            me.quote.sell_price = me.quote.selected_tier.product_cost_price * ((me.quote.markup / 100) + 1);
          }

          return me.quote.sell_price;
        }
      },

      tieredGrossProfit() {
        const me = this;
        console.log('Tiered Unit Gross Profit Computed');

        if(me.tieredNotEmpty()) {
          console.log('Tiered Unit Gross Profit Computed (Entered)');

          me.quote.gross_profit = ((((me.quote.selected_tier.product_cost_price / me.quote.selected_tier.min_qty) * ((me.quote.markup / 100) + 1)) - (me.quote.selected_tier.product_cost_price / me.quote.selected_tier.min_qty)) / ((me.quote.selected_tier.product_cost_price / me.quote.selected_tier.min_qty) * ((me.quote.markup / 100) + 1))) * 100;
          
          me.quote.gross_profit = _.round(me.quote.gross_profit, 2);
          
          return me.quote.gross_profit;
        }
      },
      /* END TIERED FUNCTIONS */

      /* NON-TIERED FUNCTIONS */
      nonTieredCostPrice() {
        const me = this;
        console.log('Non Tiered Cost Price Computed');

        if(me.nonTieredNotEmpty()) {
          console.log('Non Tiered Cost Price Computed (Entered)');

          if(me.quote.unit_price_selected) {
            me.quote.cost_price = (me.quote.selected_tier.product_cost_price * me.quote.quantity) / me.quote.quantity;
          } else {
            me.quote.cost_price = me.quote.selected_tier.product_cost_price * me.quote.quantity;
          }

          return me.quote.cost_price;
        }
      },

      nonTieredSellPrice() {
        const me = this;
        console.log('Non Tiered Sell Price Computed');

        if(me.nonTieredNotEmpty()) {
          console.log('Non Tiered Sell Price Computed (Entered)');

          if(me.quote.unit_price_selected) {
            me.quote.sell_price = (me.quote.selected_tier.product_cost_price) * ((me.quote.markup / 100) + 1);
          } else {
            me.quote.sell_price = (me.quote.selected_tier.product_cost_price * me.quote.quantity) * ((me.quote.markup / 100) + 1);
          }

          return me.quote.sell_price;
        }
      },

      nonTieredGrossProfit() {
        const me = this;
        console.log('Non Tiered Gross Profit Computed');

        if(me.nonTieredNotEmpty()) {
          console.log('Non Tiered Gross Profit Computed (Entered');

          me.quote.gross_profit = (((me.quote.selected_tier.product_cost_price / me.quote.quantity) * ((me.quote.markup / 100) + 1) - (me.quote.selected_tier.product_cost_price / me.quote.quantity)) / ((me.quote.selected_tier.product_cost_price / me.quote.quantity) * ((me.quote.markup / 100) + 1))) * 100;

          me.quote.gross_profit = _.round(me.quote.gross_profit, 2);

          return me.quote.gross_profit;
        }
      }
      /* END NON-TIERED FUNCTIONS */
    },

    methods: {
      /* SMALL FUNCTIONS FOR PRODUCT DIALOG */
      tieredNotEmpty: function() {
        const me = this;
        if(Object.keys(me.quote.selected_tier).length === 0) {
          return false;
        } else {
          return true;
        }
      },

      nonTieredNotEmpty: function() {
        const me = this;
        if(me.quote.quantity >= 1) {
          return true;
        } else {
          return false;
        }
      },

      whichTierToUse: function() {
        const me = this;
        me.quote.selected_tier = me.country_tiers.find(function (obj) { return me.quote.quantity >= obj.min_qty && me.quote.quantity <= obj.max_qty; });
      },

      calculateMargin: function(tier) {
        // return _.round((tier.product_retail_price / tier.product_cost_price) * 100, 2); // wrong forumula
        /*
        Profit margins are typically expressed as percentages. Say you own a shoe store, 
        and you sell a particular pair of sneakers for $65. If those sneakers cost you $40 
        a pair to obtain, your gross profit on each pair is $25. Your profit margin is $25 
        divided by $65 -- 0.3846, or 38.46 percent. For each dollar in revenue you get for 
        those shoes, you earn 38.46 cents in gross profit.
        
        */
        var cost = tier.product_cost_price;
        var sell = tier.product_retail_price;
        var grossProfit = sell - cost;
        var profitMargin = ((grossProfit / sell) * 100);
        return profitMargin.toFixed(2); 
      },

      handleCloseProductInfo: function() {
        const me = this;

        me.dialogVisibleProductInfo = false;
        me.active_tab = 'details';

        me.product = {product_shipping_matrix: []};
        me.country_tiers = [];
        me.selected_country = 'Ireland';
        me.primary_image = '';

        me.quote = {
          selected_tier: {},
          quantity: 0,
          markup: 0,
          unit_price_selected: 1,
          cost_price: '',
          sell_price: '',
          gross_profit: ''
        };
      },
      /* END SMALL FUNCTIONS FOR PRODUCT DIALOG */

      /* MOUNTED FUNCTIONS */
      getUser: function() {
        console.log('Get User Function');
        const me = this;

        var jwt = Utils.decodejwt();

        me.$http.get(me.config.api + 'user/{id}', {params: {id: jwt.sub}}).then(
        response => {
          console.log('Get User Function - Success Getting Data')  

          me.user = response.body.data;

          if(me.user.profile == null) {
            me.user.profile = {
              id: '',
              department: '',
              position: '',
              avatar: '',
              address_1: '',
              address_2: '',
              address_3: '',
              city: '',
              state: '',
              country: '',
              zip: '',
              telephone: '',
              mobile: '',
              fax: ''
            }
          }
        }, response => {
          console.log('Get User Function - Error Getting Data');
        });
      },

      getProductCategoryGroups: function() {
        console.log('Get Product Category Groups Function');
        const me = this;

        me.$http.get(me.config.api + 'category-group').then(
          response => {
            console.log('Get Product Category Groups Function - Success Getting Data');  

            me.product_category_groups = response.body.data;
          }, response => {
            console.log('Get Product Category Groups Function - Error Getting Data');
          }
        );
      },

      categorySelection: function(category_id) {
        console.log('Category Selection Function');
        const me = this;
        
        me.product_category_id = category_id;
        me.picked_category = true;
        
        me.search();
      },

      getProductCategories: function() {
        console.log('Get Product Categories Function');
        const me = this;
          me.$http.get(me.config.api + 'productCategory').then(
          response => {
            console.log('Get Product Categories Function - Success Getting Data');  

            me.product_categories = response.body.data;
          }, response => {
            console.log('Get Product Categories Function - Error Getting Data');
          }
        );
      },
      /* END MOUNTED FUNCTIONS */

      getProducts: function(goToPage) {
        console.log('Get Products Function');
        const me = this;
        me.loading = true;
        me.$http.get(me.config.api + 'product', {params: {admin: 1, page: goToPage, sort_by: me.sort_by_field_name, order: me.sort_by_order}}).then(
          response => {
          console.log('Get Products Function - Success Getting Data')  
         
          me.products = response.body.data;
          me.handlePagination(response);

          me.loading = false;
        }, response => {
          console.log('Get Products Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });

          me.loading = false;
        });
      },

      search: function(goToPage) {
        console.log('Search Function');
        const me = this;
        me.loading = true;
        me.$http.get(me.config.api + 'product-search', {params: {product_category_id: me.product_category_id, admin: 1, search_terms: me.search_terms, page: goToPage, sort_by: me.sort_by_field_name, order: me.sort_by_order}}).then(
          response => {
          console.log('Search Function - Success Getting Data')  

          me.products = response.body.data;
          me.handlePagination(response);

          me.loading = false;
        }, response => {
          console.log('Search Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });

          me.loading = false;
        });
      },

      handlePagination: function(response) {
        const me = this;

        me.pagination.total = response.body.total;
        me.pagination.per_page = response.body.per_page;
        me.pagination.current_page = response.body.current_page;
        me.pagination.last_page = response.body.last_page;
        me.pagination.next_page_url = response.body.next_page_url;
        me.pagination.prev_page_url = response.body.prev_page_url;
        me.pagination.from = response.body.from;
        me.pagination.to = response.body.to;
			},

      handleCurrentChange(val) {
        const me = this;
        if(me.product_category_id != '' || me.search_terms != '') {
          me.search(val);
        } else {
          me.getProducts(val);
        }
        window.scrollTo(0, 0);
      },

      getProduct: function(id) {
        console.log('Get Product Function');
        const me = this;

        me.loading = true;

        me.$http.get(me.config.api + 'product/{id}', {params: {admin: 1, id: id}}).then(
          response => {
          console.log('Get Product Function - Success Getting Data')  

          me.product = response.body.data;
          
          me.getCountryTiers();
          me.dialogVisibleProductInfo = true;
          me.primary_image = me.product.product_images[0].path;

          me.loading = false;
        }, response => {
          console.log('Get Product Function - Error Getting Data');
          me.dialogVisibleProductInfo = false;
        });
        me.loading = false;
      },

      changePrimaryImage: function(selectedImg) {
        const me = this;
        console.log('Change Primary Image Function', selectedImg);
        me.primary_image = selectedImg;
      },

      getCountryTiers: function() {
        console.log('Get Country Tiers Function');  
        const me = this;
        me.$http.get(me.config.api + 'product/{id}/pricing', {params: {admin: 1, id : me.product.id, country: me.selected_country}}).then(
        response => {
          console.log('Get Country Tiers Function - Success Getting Data');  

          me.country_tiers = response.body.data;

          if(!me.product.is_tiered && me.country_tiers.length > 0) {
            me.quote.selected_tier = me.country_tiers[0];
            me.non_tiered_minimum = me.country_tiers[0].min_qty;
            me.non_tiered_maximum = me.country_tiers[me.country_tiers.length-1].min_qty;
          }
        }, response => {
          console.log('Get Country Tiers Function - Error Getting Data');
        });
      },

      addToQuote: function(product) {
        const me = this;
        me.loading_add_to_quote = true;

        /* CHECKS IF A QUOTE ALREADY EXISTS FOR A PRODUCT */
        var my_obj = me.quotes.find(function (obj) { return obj.id === me.product.id; });

        if(my_obj != undefined) {
          console.log('Quote Item Exists - Push Pricing ');

          var pricing = {
            quantity: '',
            price: me.quote.sell_price,
            turnaround_time: me.quote.selected_tier.product_turnaround_time,
            unit_price_selected: me.quote.unit_price_selected
          }

          if(product.is_tiered) {
            pricing.quantity = me.quote.selected_tier.min_qty;
          } else {
            pricing.quantity = me.quote.quantity;
          }
          
          my_obj.pricing.push(pricing); 

          me.handleCloseProductInfo();

          me.$notify({
            title: 'Success',
            message: 'The item was added to your quote',
            type: 'success'
          });

          me.loading_add_to_quote = false;
        } else {
          console.log('Quote Item Does Not Exist - Push Product And Pricing ');

          var quoteItem = {
            id: product.id, 
            name: product.name, 
            primary_image: me.primary_image, 
            images: product.product_images,
            base64_image: '',
            short_description: product.short_description,
            specification: product.specification,
            pricing: [
              {
                quantity: '',
                price: me.quote.sell_price,
                turnaround_time: me.quote.selected_tier.product_turnaround_time,
                unit_price_selected: me.quote.unit_price_selected
              }
            ],
          };

          if(product.is_tiered) {
            quoteItem.pricing[0].quantity = me.quote.selected_tier.min_qty;
          } else {
            quoteItem.pricing[0].quantity = me.quote.quantity;
          }

          me.quotes.push(quoteItem);

          me.handleCloseProductInfo();

          me.$notify({
            title: 'Success',
            message: 'The item was added to your quote',
            type: 'success'
          });
          
          me.loading_add_to_quote = false;
        }
      } //END LAST METHOD
    } //END METHODS
  }
</script>


// WEBPACK FOOTER //
// src/pages/reps/ProductCatalogue.vue